import { GameLoaderType } from '@crazygames/game-types/src/game-build/loader.type';

/** These Unity versions allow the devs to select brotli/gzip compression */
export const unityLoadersWithCompression: GameLoaderType[] = [
  'unity6',
  'unity2023',
  'unity2022',
  'unity2021',
  'unity2020',
  'unity2019',
  'unity2018',
  'unity2017',
  '5.6.x',
];

/**
 * These game loader versions display the toggles so the dev can tell us how the game saves data,
 * and also allow displaying a custom file name field, for when the game stores data in file.
 * Keep in sync DP and Graph.
 */
export const unityLoadersWithDataSave: GameLoaderType[] = [
  'unity6',
  'unity2023',
  'unity2022',
  'unity2021',
  'unity2020',
  'unity2019',
  'unity2018',
  'unity2017',
  '5.6.x',
];

/** These game loader versions display the toggles so the dev can tell us how the game saves data. */
export const loadersWithSaveDataToggles: GameLoaderType[] = ['html5', 'iframe', ...unityLoadersWithDataSave];

/**
 * These Unity versions benefit from the sitelock.
 * Keep DP and Graph in sync.
 */
export const LOADERS_WITH_SITELOCK: GameLoaderType[] = [
  'unity6',
  'unity2023',
  'unity2022',
  'unity2021',
  'unity2020',
  'unity2019',
  'unity2018',
  'unity2017',
  '5.6.x',
];

export const standaloneLoaders: GameLoaderType[] = [
  'unity6',
  'unity2023',
  'unity2022',
  'unity2021',
  'unity2020',
  'unity2019',
  'unity2018',
  'unity2017',
  '5.6.x',
  'iframe',
  'html5',
];

/** These game engines will display the iOS/Android friendly toggles */
export const MOBILE_FRIENDLY_LOADERS: GameLoaderType[] = [
  'unity6',
  'unity2023',
  'unity2022',
  'unity2021',
  'unity2020',
  'unity2019',
  'unity2018',
  'unity2017',
  '5.6.x',
  'iframe',
  'html5',
];

export function gameLoaderTypeToName(gameLoaderType: GameLoaderType): string {
  switch (gameLoaderType) {
    case 'unity6':
      return 'Unity 6';
    case 'unity2023':
      return 'Unity 2023';
    case 'unity2022':
      return 'Unity 2022';
    case 'unity2021':
      return 'Unity 2021';
    case 'unity2020':
      return 'Unity 2020';
    case 'unity2019':
      return 'Unity 2019';
    case 'unity2018':
      return 'Unity 2018';
    case 'unity2017':
      return 'Unity 2017';
    case '5.6.x':
      return 'Unity 5.6';
    case 'iframe':
      return 'Externally hosted (iframe)';
    case 'html5':
      return 'HTML5';
    case 'godot':
      return 'Godot';
    case 'defold':
      return 'Defold';
    case 'gamemaker':
      return 'GameMaker';
    case 'gdevelop':
      return 'GDevelop';
    case 'cocos':
      return 'Cocos';
    case 'playcanvas':
      return 'PlayCanvas';
    case 'unreal':
      return 'Unreal';
    case 'construct':
      return 'Construct';
    default:
      throw new Error(`Unmapped GameType: ${gameLoaderType}`);
  }
}
